import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from './config.service';
import { AuthService } from './auth.service';
import { GetCarAndLoaderRequest, GetCarAndLoaderResponse} from '../models/courier.models';
import { GetContactsRequest, GetContactsResponse } from '../models/contacts.models';

@Injectable({
  providedIn: 'root'
})
export class ContactsService {
  private apiUrl: string;

  constructor(private http: HttpClient, private configService: ConfigService, private authService: AuthService) {
    this.apiUrl = this.configService.getConfig().apiBaseUrl;
  }

  private getHeaders(): HttpHeaders {
    const token = this.authService.getToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  }

  private getQueryParams(params: any): HttpParams {
    let httpParams = new HttpParams();
    Object.keys(params).forEach(key => {
      httpParams = httpParams.append(key, params[key]);
    });
    return httpParams;
  }

  getContacts(request: GetContactsRequest): Observable<GetContactsResponse> {
    return this.http.get<GetContactsResponse>(`${this.apiUrl}/Contacts/get-contacts`, { 
      headers: this.getHeaders(), 
      params: this.getQueryParams(request) 
    });
  }
}